import { LoadingButton } from "@mui/lab";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";

import { CommentActionsProps } from "../../../../types/components/props.type";
import { useCommentLikeMutation } from "../../../../api/mutations/useCommentLikeMutation";
import { CommentLikeCountIcon } from "../../../../assets/icons/create-feed";

const CommentActions = ({
  likesCount,
  timeAgo,
  handleReply,
  isLiked,
  commentId,
  postId,
  isReply,
}: CommentActionsProps) => {
  const { t } = useTranslation("feed", { keyPrefix: "comment" });
  const { likeComment, unlikeComment, isLiking, isUnliking } = useCommentLikeMutation({
    commentId,
    postId,
  });

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <Box sx={{ display: "flex", gap: "16px", alignItems: "center" }}>
        <Typography
          sx={{
            color: "var(--Dark---800, #414141)",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          {timeAgo}
        </Typography>
        <LoadingButton
          sx={{
            color: "var(--Dark---1000, #111)",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontWeight: 600,
            lineHeight: "20px",
            padding: 0,
            minWidth: "unset",
            background: "transparent !important",
          }}
          onClick={() => (isLiked ? unlikeComment() : likeComment())}
          loading={isLiking || isUnliking}
        >
          {isLiked ? t("unlike") : t("like")}
        </LoadingButton>
        {!isReply && (
          <Button
            sx={{
              color: "var(--Dark---1000, #111)",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontWeight: 600,
              lineHeight: "20px",
              padding: 0,
              minWidth: "unset",
              background: "transparent !important",
            }}
            disableRipple
            onClick={handleReply}
          >
            {t("reply")}
          </Button>
        )}
      </Box>

      <Box sx={{ display: "flex", gap: "4px", alignItems: "center" }}>
        <Typography
          sx={{
            color: "var(--Dark---1000, #111)",
            fontFamily: "Nunito Sans, Montserrat",
            fontSize: "14px",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          {likesCount}
        </Typography>
        <CommentLikeCountIcon fill={isLiked ? "#FF4D4E" : "none"} />
      </Box>
    </Box>
  );
};

export default CommentActions;
